import React from 'react';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/shoppings/shoppingList';
import ShoppingListItemContainer from '@/containers/shoppings/ShoppingListItemContainer';
import { IShopping } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  shoppingList: IShopping[];
};

const ShoppingList: React.FC<ComponentProps> = ({ shoppingList }) => {
  const classes = useStyles();

  return (
    <div className={classes.section}>
      {shoppingList.length === 0 ? (
        <p className={classes.textCenter}>お探しのアイテムはありません</p>
      ) : (
        <GridContainer>
          {shoppingList.map((item, index) => {
            return (
              <ShoppingListItemContainer
                shopping={item}
                key={`shopping-item-${index.toString()}`}
              />
            );
          })}
        </GridContainer>
      )}
    </div>
  );
};

export default ShoppingList;
